import { render, staticRenderFns } from "./carAttr.vue?vue&type=template&id=637ee422&scoped=true&"
import script from "./carAttr.vue?vue&type=script&lang=js&"
export * from "./carAttr.vue?vue&type=script&lang=js&"
import style0 from "./carAttr.vue?vue&type=style&index=0&id=637ee422&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "637ee422",
  null
  
)

export default component.exports